import React from 'react';
import { Grid, Paper, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useMessages } from 'modules/intl';
import { useFormattedDuration } from 'modules/notes/common';
import { SummaryHoursLabels, TransformReturnType } from './utils';

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(0, 2),
    marginRight: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    width: '34%',
    justifyContent: 'space-between'
  },
  acceptContainer: {
    display: 'flex',
    flexDirection: 'column',
    margin: theme.spacing(1)
  },

  grid: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%'
  },

  label: {
    color: theme.palette.text.secondary
  },
  div: {
    display: 'flex',
    flexDirection: 'row',
    alignSelf: 'center'
  }
}));

const labels = [
  `insights.summaryHours.${SummaryHoursLabels.scheduled}`,
  `insights.summaryHours.${SummaryHoursLabels.worked}`,
  `insights.summaryHours.${SummaryHoursLabels.remaining}`
];

type SummaryComponentProp = {
  tranformData: TransformReturnType;
};
export const SummaryComponent: React.FC<SummaryComponentProp> = ({
  tranformData
}: SummaryComponentProp) => {
  const classes = useStyles();
  const messages = useMessages(labels);

  return (
    <>
      <Paper
        className={classes.container}
        elevation={3}
        data-testid={'summary-container'}
        tabIndex={0}
      >
        <Grid flexWrap={'wrap'} className={classes.grid}>
          <div
            className={classes.acceptContainer}
            data-testid={'hours-summary-scheduled'}
          >
            <Typography
              variant="body2"
              whiteSpace="nowrap"
              className={classes.label}
            >
              {
                messages[
                  `insights.summaryHours.${SummaryHoursLabels.scheduled}`
                ]
              }
            </Typography>
            <div className={classes.div}>
              {useFormattedDuration({
                duration: tranformData[SummaryHoursLabels.scheduled],
                needsMask: true
              })}
            </div>
          </div>
          <div
            className={classes.acceptContainer}
            data-testid={'hours-summary-worked'}
          >
            <Typography
              variant="body2"
              whiteSpace="nowrap"
              className={classes.label}
            >
              {messages[`insights.summaryHours.${SummaryHoursLabels.worked}`]}
            </Typography>
            <div className={classes.div}>
              {useFormattedDuration({
                duration: tranformData[SummaryHoursLabels.worked],
                needsMask: true
              })}
            </div>
          </div>
          <div
            className={classes.acceptContainer}
            data-testid={'hours-summary-remaining'}
          >
            <Typography
              variant="body2"
              whiteSpace="nowrap"
              className={classes.label}
            >
              {
                messages[
                  `insights.summaryHours.${SummaryHoursLabels.remaining}`
                ]
              }
            </Typography>
            <div className={classes.div}>
              {useFormattedDuration({
                duration: tranformData.remaining,
                needsMask: true
              })}
            </div>
          </div>
        </Grid>
      </Paper>
    </>
  );
};
